import React from "react";

export function Meeting() {
    return (
        <center>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <a href="https://diuy0t6boke2n.cloudfront.net/20250509130453068.pdf"><button >2025 Meeting Dates & Reorganization resolutions</button></a>
            <br/><br/>
        </center>
    )
} 